import { render } from "./HeaderShow.vue?vue&type=template&id=80c45fd0&scoped=true"
import script from "./HeaderShow.vue?vue&type=script&lang=js"
export * from "./HeaderShow.vue?vue&type=script&lang=js"

import "./HeaderShow.vue?vue&type=style&index=0&id=80c45fd0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c45fd0"],['__file',"src/views/AfterSales/editTask/components/HeaderShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80c45fd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80c45fd0', __exports__)) {
    api.reload('80c45fd0', __exports__)
  }
  
  module.hot.accept("./HeaderShow.vue?vue&type=template&id=80c45fd0&scoped=true", () => {
    api.rerender('80c45fd0', render)
  })

}


export default __exports__